/**
 * The one RAG band for a readiness average on the 0-5 scale, identical to the server's snapshot heatmap
 * (backend services/gapDashboardSnapshot.ts: avg >= 4 green, avg >= 2 amber, else red). Every Gap Analysis
 * surface (domain tiles, report table, Annex A heatmap, score badges) colours through this so the same
 * score never reads green on one screen and amber on another.
 */
export const RAG_MAX_SCORE = 5;
export const RAG_GREEN_MIN = 4;
export const RAG_AMBER_MIN = 2;

/** @returns {'green'|'amber'|'red'|null} null when there is nothing to rate. */
export function ragBandForAvg(avg) {
  if (typeof avg !== 'number' || Number.isNaN(avg)) return null;
  if (avg >= RAG_GREEN_MIN) return 'green';
  if (avg >= RAG_AMBER_MIN) return 'amber';
  return 'red';
}

/** Same band for a score out of `max` (e.g. 3 of 5, or 60 of 100). */
export function ragBandForScore(score, max) {
  if (typeof score !== 'number' || !(max > 0)) return null;
  return ragBandForAvg((score / max) * RAG_MAX_SCORE);
}

/** Same band for a percentage of the maximum (an average of 3.5 is 70%). */
export function ragBandForPercent(pct) {
  return ragBandForScore(pct, 100);
}

export const RAG_BG_CLASS = { green: 'bg-emerald-500', amber: 'bg-amber-500', red: 'bg-rose-500' };
export const RAG_TEXT_CLASS = { green: 'text-emerald-600', amber: 'text-amber-600', red: 'text-rose-600' };
